import React, { useMemo } from 'react';
import DetailSidebarApply from './DetailSidebarApply';
import DetailSidebarRequirements from './DetailSidebarRequirements';
import DetailSidebarBottom from './DetailSidebarBottom';
import KpathportBanner from '../../KpathportBanner';
import DetailSidebarBlackBanner from './DetailSidebarBlackBanner';

const DetailSidebar = ({
  className = '',
  job,
  optionMeta,
  isSaved,
  isHidden,
  hasApplied,
  onApplied,
  onToggleSave,
  onToggleHide,
}) => {
  const Banner = useMemo(() => {
    return Math.random() < 0.5 ? (
      <KpathportBanner />
    ) : (
      <DetailSidebarBlackBanner />
    );
  }, []);

  return (
    <div className={`w-full tabletV:w-auto ${className}`}>
      <div className='flex flex-col items-start p-0 gap-6 w-full tabletV:max-w-[274px]'>
        <div className='hidden tabletV:block w-full'>
          <DetailSidebarApply
            job={job}
            hasApplied={hasApplied}
            onApplied={onApplied}
          />
        </div>

        <DetailSidebarBottom
          className='hidden tabletV:flex'
          isSaved={isSaved}
          isHidden={isHidden}
          onToggleSave={onToggleSave}
          onToggleHide={onToggleHide}
        />

        <DetailSidebarRequirements job={job} optionMeta={optionMeta} />

        <div className='hidden w-full tabletV:block'>{Banner}</div>
      </div>
    </div>
  );
};

export const DetailPromoBanner = () => {
  const Banner = useMemo(
    () =>
      Math.random() < 0.5 ? <KpathportBanner /> : <DetailSidebarBlackBanner />,
    [],
  );

  return <div className='w-full tabletV:hidden'>{Banner}</div>;
};

export default DetailSidebar;
